import { Button, Chip, Box } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

export const getVendorColumns = (onEdit, onDelete) => [
  {
    accessorKey: "id",
    header: "ID",
    size: 80,
    Cell: ({ cell }) => (
      <Box sx={{ color: "text.secondary", fontWeight: "medium" }}>
        #{cell.getValue()}
      </Box>
    ),
  },
  {
    accessorKey: "name",
    header: "Vendor Name",
    Cell: ({ cell }) => (
      <Box sx={{ fontWeight: "600", fontSize: "0.95rem" }}>
        {cell.getValue()}
      </Box>
    ),
  },
  {
    accessorKey: "contactPerson",
    header: "Contact Person",
    Cell: ({ cell }) =>
      cell.getValue() || (
        <Box sx={{ color: "text.secondary", fontStyle: "italic" }}>
          Not specified
        </Box>
      ),
  },
  {
    accessorKey: "phone",
    header: "Phone",
    Cell: ({ cell }) =>
      cell.getValue() || (
        <Box sx={{ color: "text.secondary", fontStyle: "italic" }}>
          Not provided
        </Box>
      ),
  },
  {
    accessorKey: "city",
    header: "City",
    Cell: ({ cell }) =>
      cell.getValue() || (
        <Box sx={{ color: "text.secondary", fontStyle: "italic" }}>
          Not specified
        </Box>
      ),
  },
  {
    accessorKey: "status",
    header: "Status",
    Cell: ({ cell }) => {
      const status = cell.getValue();
      const isActive = status === 1;

      return (
        <Chip
          label={isActive ? "Active" : "Inactive"}
          color={isActive ? "success" : "default"}
          size="small"
          variant="filled"
          sx={{
            fontWeight: "bold",
            minWidth: 80,
          }}
        />
      );
    },
  },
  {
    accessorKey: "actions",
    header: "Actions",
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<Edit />}
          onClick={() => onEdit(row.original)}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            fontWeight: "medium",
          }}
        >
          Edit
        </Button>
        <Button
          size="small"
          color="error"
          variant="outlined"
          startIcon={<Delete />}
          onClick={() => onDelete(row.original)}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            fontWeight: "medium",
          }}
        >
          Delete
        </Button>
      </Box>
    ),
  },
];
